module.exports = __webpack_public_path__ + "img/icon.52f607da.svg";